import { render, staticRenderFns } from "./CreateInvoices.vue?vue&type=template&id=71f904fa&scoped=true&"
import script from "./CreateInvoices.vue?vue&type=script&lang=js&"
export * from "./CreateInvoices.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoices.vue?vue&type=style&index=0&id=71f904fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f904fa",
  null
  
)

export default component.exports